import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { QuoteInfoService } from '../../services/quote-info.service';
import { ModelService } from '../../services/model.service';
import { ApplicationStateService } from '../../services/application-state.service';
import { CurrentUserService } from '../../services/current-user.service';
import { BrowserWidthService } from '../../services/browser-width.service';
import { CustomerService } from '../../services/customer.service';
import { NavigationService } from '../../services/navigation.service';

import { Constants } from '../../model/constants';
import { Quote } from '../../model/quote';
import { Customer } from '../../model/customer';
import { Number } from 'core-js/library/web/timers';

@Component({
  selector: 'mch-navigation',
  template: require('./mch-navigation.component.html'),
  styles: [require('./mch-navigation.component.scss')]
})
export class MchNavigationComponent implements OnDestroy, OnInit {
  routes: Array<any> = Constants.MchNavCategories.filter(
    route => route.isHidden === false
  );
  allRoutes: Array<any> = Constants.MchNavCategories;
  quote: Quote;
  subscription: Subscription = new Subscription();
  customer: Customer;

  constructor(
    public router: Router,
    public quoteInfoService: QuoteInfoService,
    public modelService: ModelService,
    public appStateService: ApplicationStateService,
    public browserWidthService: BrowserWidthService,
    public customerService: CustomerService,
    public navigationService: NavigationService
  ) {}

  ngOnInit() {
    const quoteSub = this.quoteInfoService.quote$.subscribe((x: Quote) => {
      this.quote = x;
      if (
        this.quote.productLineId === null ||
        this.quote.productLineId === undefined
      ) {
        this.routes = Constants.MchNavCategories.filter(
          route => route.name === 'Product Lines' || route.name === 'Customer'
        );
      }
    });
    this.subscription.add(quoteSub);

    const customerSub = this.quoteInfoService.customer$.subscribe(
      (x: Customer) => {
        this.customer = x;
      }
    );
    this.subscription.add(customerSub);
  }

  get currentPage() {
    return this.allRoutes.find(x => {
      return this.router.url.includes(x.link);
    });
  }

  navigateMch(url: string) {
    const canAccessQuoteSub = this.quoteInfoService.canAccessQuote$.subscribe(
      x => {
        if (x === true) {
          if (window.location.href.includes('customer-info')) {
            if (
              (this.quote === undefined ||
                this.quote === null ||
                this.quote.quoteId === undefined ||
                this.quote.quoteId === null ||
                this.quote.quoteId === 0) &&
              this.customer !== undefined &&
              this.customer !== null &&
              this.customer.firstName !== undefined &&
              this.customer.firstName !== null &&
              this.customer.firstName !== '' &&
              this.customer.lastName !== undefined &&
              this.customer.lastName !== null &&
              this.customer.lastName !== ''
            ) {
              this.customerService
                .insertCustomer(this.customer)
                .subscribe(cust => {
                  this.appStateService.setCustomer(cust).subscribe(quote => {
                    this.quoteInfoService.customerId$.next(quote.customerId);
                    this.quoteInfoService.quoteId$.next(quote.quoteId);
                    this.quoteInfoService.customer$.next(cust);
                    this.quote = quote;
                    this.router.navigate([url, this.quote.quoteId]);
                  });
                });
            } else {
              this.router.navigate([url, this.quote.quoteId]);
            }
          } else {
            if (url.includes('customer-info')) {
              this.router.navigate([url, this.quote.quoteId]);
            } else if (url.includes('/sales/quotes')) {
              window.location.href = url;
            } else if (url.includes('options-configuration')) {
              let ssId = sessionStorage.getItem('categoryId');
              if (ssId && this.quote.quoteId) {
                this.router.navigate([url, this.quote.quoteId, ssId]);
              } else if (this.quote.quoteId) {
                this.router.navigate([url, this.quote.quoteId]);
              }
            } else {
              if (
                url.includes('product-line') &&
                window.location.href.includes('choose-model')
              ) {
                this.modelService.navigateBackToProductLine$.next(true);
              }
              this.router.navigate([url, this.quote.quoteId]);
            }
          }
        }
      }
    );
    this.subscription.add(canAccessQuoteSub);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/mch-navigation/mch-navigation.component.ts